import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';
import { LinksListField } from '../fields/LinksList';
import {
  linksListUiOptionsSchema,
  linksListValueSchema,
} from '../schemas/linksListSchema';

export const linksListFieldExtension: any = FormFieldBlueprint.make({
  name: 'links-list-picker',
  params: {
    field: async () =>
      createFormField({
        name: 'LinksListPicker',
        component: LinksListField,
        schema: makeFieldSchema({
          output: () => linksListValueSchema,
          uiOptions: () => linksListUiOptionsSchema,
        }),
      }),
  },
});
